import { useEffect, useState } from 'react';
import apiService from '../../../../services/api.service';
import buildActivityChartOptions from '../../../../utils/dashboard/build-activity-chart-options';
import generateDailyCategories from '../../../../utils/dashboard/generate-daily-categories';
import useHeadDepartment from './useHeadDepartment';

const fetchEmployeesActivity = async ({
  pickedEmployees,
  startPickerValue,
  endPickerValue,
  departmentId,
}) => {
  if (!departmentId) return { categories: [], series: [] };

  const userIdsString = pickedEmployees.map((user) => user.id).join(',');
  const dayEventStatistic = await apiService.head.getHeadUsersDashboardStatistic(
    [
      `startDate=${startPickerValue.toISOString()}`,
      `endDate=${endPickerValue.toISOString()}`,
      `userIds=${userIdsString}`,
      `departmentId=${departmentId}`,
    ].join('&'),
  );

  const categories = generateDailyCategories(startPickerValue, endPickerValue);
  const series = [
    { name: 'LINK_CLICKED', data: Array(categories.length).fill(0) },
    { name: 'DONE', data: Array(categories.length).fill(0) },
    { name: 'ON_HOLD', data: Array(categories.length).fill(0) },
    { name: 'IN_PROGRESS', data: Array(categories.length).fill(0) },
  ];

  Object.keys(dayEventStatistic).forEach((key) => {
    const date = key;
    const eventCount = dayEventStatistic[date];

    const index = categories.indexOf(date);
    if (index > -1) {
      series.forEach((item) => {
        Reflect.set(item.data, index, eventCount[item.name] || 0);
      });
    }
  });

  return { categories, series };
};

const useEmployeesActivity = ({ startPickerValue, endPickerValue, pickedEmployees }) => {
  const [employeesChartSeries, setEmployeesChartSeries] = useState([]);
  const [employeesChartOptions, setEmployeesChartOptions] = useState({});
  const { departmentId, loading } = useHeadDepartment();

  useEffect(() => {
    if (
      Number.isNaN(startPickerValue.toDate().valueOf()) ||
      Number.isNaN(endPickerValue.toDate().valueOf())
    )
      return;

    if (loading || !departmentId) return;

    const loadData = async () => {
      const { categories, series } = await fetchEmployeesActivity({
        pickedEmployees,
        startPickerValue,
        endPickerValue,
        departmentId,
      });

      setEmployeesChartSeries(series);
      setEmployeesChartOptions(buildActivityChartOptions({ categories }));
    };

    loadData();
  }, [pickedEmployees, startPickerValue, endPickerValue, departmentId, loading]);

  return {
    employeesChartSeries,
    employeesChartOptions,
  };
};

export default useEmployeesActivity;
